module.exports = __webpack_public_path__ + "assets/img/poster-employment_01.684f6f50.jpg";